import { Component } from '@theme/component';

/**
 * <hd-countdown data-target="2026-09-18T20:00:00+02:00">
 * Met à jour les refs days/hours/minutes/seconds chaque seconde.
 * Passe en data-state="expired" (et montre la ref `expired`) une fois la date atteinte.
 */
class HdCountdown extends Component {
  requiredRefs = ['days', 'hours', 'minutes', 'seconds', 'expired'];

  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    super.connectedCallback();
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearInterval(this.#timer);
  }

  #tick() {
    const target = Date.parse(this.dataset.target ?? '');
    if (Number.isNaN(target)) return;

    const diff = target - Date.now();
    if (diff <= 0) {
      this.dataset.state = 'expired';
      this.refs.expired.hidden = false;
      window.clearInterval(this.#timer);
      return;
    }

    const total = Math.floor(diff / 1000);
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    this.refs.days.textContent = String(days);
    this.refs.hours.textContent = String(hours).padStart(2, '0');
    this.refs.minutes.textContent = String(minutes).padStart(2, '0');
    this.refs.seconds.textContent = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('hd-countdown')) customElements.define('hd-countdown', HdCountdown);
